// import React from 'react';
// import './Gallery.css';
// import { galleryImages } from '../../assets/exports';


// const Gallery = () => {
//   return (
//     <div className="gallery">
//       <h2 className="gallery-title">Our Gallery</h2>
//       <p className="gallery-description">Snapshots of the people, projects, and progress in Igboeze North.</p>
//       <div className="gallery-grid">
//         {galleryImages.map((item, index) => (
//           <div key={index} className="gallery-item">
//             <img src={item.image} alt={item.caption} />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Gallery;


import React, { useEffect, useState } from 'react';
import './Gallery.css';
import publicAxios from '../../utils/axios/publicAxios';
import { Circles } from 'react-loader-spinner';

const Gallery = () => {
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        setLoading(true);
        const res = await publicAxios.get('/public/gallery');
        setGallery(res.data.gallery || []);
      } catch (error) {
        console.error('Failed to fetch gallery:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, []);

  return (
    <div className="gallery">
      <h2 className="gallery-title">Our Gallery</h2>
      <p className="gallery-description">
        Snapshots of the people, projects, and progress in Igboeze North.
      </p>

      {loading ? (
        <div className="gallery-loading">
          <Circles height="40" width="40" color="#008751" />
        </div>
      ) : (
        <div className="gallery-grid">
          {gallery.length ? (
            gallery.map((item) => (
              <div key={item._id} className="gallery-item">
                <img src={item.imageUrl} alt={item.title} loading="lazy" />
              </div>
            ))
          ) : (
            <p className="gallery-empty">No images to display.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default Gallery;